import "./CarouselVert.css";

const CarouselVert = ({ children }) => {
  return (
    <div className="CarouselVert">
      <div className="CarouselVert-content">{children}</div>
    </div>
  );
};

export default CarouselVert;
